const s = (n, e) => {
  let t;
  return function(...i) {
    const r = () => {
      clearTimeout(t), n(...i);
    };
    t && clearTimeout(t), t = setTimeout(r, e);
  };
};
function c(n) {
  const e = n.trim();
  if (e.length === 0)
    return "-";
  const t = e.split(/\s+/), o = t[0][0].toUpperCase(), i = t.length > 1 ? t[t.length - 1][0].toUpperCase() : "";
  return o + i;
}
export {
  s as debounce,
  c as getInitials
};
//# sourceMappingURL=functions.js.map
